package com.mps.asc_app.ui.screens

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.mps.asc_app.util.PRIVACY_CONSENT_TEXT

@Composable
fun PrivacyConsentScreen(
    modifier: Modifier = Modifier,
    onAccept: () -> Unit,
    onLogout: (() -> Unit)? = null,
    isAccepting: Boolean = false,
    error: String? = null,
) {
    var localAccepted by remember { mutableStateOf(false) }

    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(24.dp)
            .verticalScroll(rememberScrollState()),
        verticalArrangement = Arrangement.spacedBy(12.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            text = "Datenschutzerklaerung",
            style = MaterialTheme.typography.headlineSmall,
            textAlign = TextAlign.Center
        )

        Text(
            text = "Um das Buchungstool weiter zu nutzen, musst du der folgenden Datenschutzerklaerung zustimmen.",
            style = MaterialTheme.typography.bodyMedium,
            textAlign = TextAlign.Center
        )

        Spacer(Modifier.height(6.dp))

        Text(
            text = PRIVACY_CONSENT_TEXT,
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant
        )

        Spacer(Modifier.height(8.dp))

        Row(
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Checkbox(
                checked = localAccepted,
                onCheckedChange = { checked -> localAccepted = checked },
                enabled = !isAccepting
            )
            Text("Ich stimme zu")
        }

        error?.let {
            Text(
                text = it,
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.error,
                textAlign = TextAlign.Center
            )
        }

        Spacer(Modifier.height(8.dp))

        if (isAccepting) {
            CircularProgressIndicator()
        } else {
            Button(
                enabled = localAccepted,
                onClick = onAccept
            ) {
                Text("Weiter")
            }
        }

        if (onLogout != null) {
            Spacer(Modifier.height(8.dp))
            OutlinedButton(onClick = onLogout) {
                Text("Abmelden")
            }
        }
    }
}

